import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { shopMapsLink } from "../lib/site";

const pin = L.divIcon({
  className: "",
  html: '<div class="mhm-pin"><span></span></div>',
  iconSize: [34, 44],
  iconAnchor: [17, 44],
  popupAnchor: [0, -40],
});

const FitBounds = ({ points }) => {
  const map = useMap();
  useEffect(() => {
    if (points.length === 1) map.setView(points[0], 13);
    else if (points.length > 1) map.fitBounds(points, { padding: [50, 50], maxZoom: 13 });
  }, [map, points]);
  return null;
};

export default function ShopsMap({ shops, height = "h-[460px]" }) {
  const located = (Array.isArray(shops) ? shops : []).filter((s) => typeof s.lat === "number" && typeof s.lng === "number");
  if (located.length === 0) return null;
  const points = located.map((s) => [s.lat, s.lng]);

  return (
    <div data-testid="shops-map" data-lenis-prevent className={`relative z-0 overflow-hidden rounded-[28px] border border-navy/10 ${height}`}>
      <MapContainer center={points[0]} zoom={11} scrollWheelZoom={false} className="h-full w-full">
        <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <FitBounds points={points} />
        {located.map((s) => (
          <Marker key={s.id} position={[s.lat, s.lng]} icon={pin}>
            <Popup minWidth={220} maxWidth={260}>
              <div data-testid={`shop-popup-${s.id}`} className="w-[220px]">
                {s.photo && <img src={s.photo} alt={s.name} className="mb-2 h-28 w-full rounded-lg object-cover" />}
                {s.branch && <p className="font-mono text-[10px] uppercase tracking-widest text-brand">{s.branch}</p>}
                <p className="font-display text-lg font-bold uppercase leading-tight text-navy">{s.name}</p>
                <p className="mt-1 text-xs text-slate-600">{[s.address, s.district, s.state, s.pincode].filter(Boolean).join(", ") || "Address to be updated"}</p>
                <a href={shopMapsLink(s)} target="_blank" rel="noreferrer" className="mt-2 inline-block text-xs font-semibold text-brand">Get directions →</a>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
}
